import { ZoneMasterThemeSizeConfig } from './types';

const large: ZoneMasterThemeSizeConfig = {
  zoneMaster: {},
};

export default large;
